import TinyUri from 'tiny-uri';
import delay from 'delay';

import makeVueModal from '@/views/modal/make_vue_modal';
import CustomSelect from '@/views/custom_select';
import PopperTooltipV4 from '@/views/popper_tooltip_v4';
import ComposableForm from '@/views/composable_form';

import asyncSweetScroll from '@/helpers/sweet_scroll';
import axios from '@/helpers/axios';
import isVisibleInViewport from '@/helpers/is_visible_in_viewport';
import track from '@/helpers/track';
import { isMobile } from '@/helpers/mobile_detect';

const LOCK_RADIO_SELECTOR = 'input[name="order[simple_lock_product_id]"]';
let authModal = null;

$(document).on('turbolinks:before-cache', () => {
  if (authModal) {
    authModal.destroy();
    authModal = null;
  }
});

pageLoad('.orders-v4', () => {
  $('.order-column')
    .on('order-column:process', process)
    .trigger('order-column:process');

  const $form = $('form.order-column, form.profile-form');

  $form
    .on('click', 'input[type=submit], a.final-submit, a.next', async e => {
      const $confirmWrapper = $form.find('.b-input-v4.agreement-confirmation');
      const $confirmInput = $confirmWrapper.find('input[type=checkbox]');
      let isScrolled = false;

      if ($(LOCK_RADIO_SELECTOR).length && !$(`${LOCK_RADIO_SELECTOR}:checked`).length) {
        e.preventDefault();
        e.stopImmediatePropagation();

        const $lockSection = $('.section-lock');

        $lockSection.find('.error-message').removeClass('hidden');

        if (!isVisibleInViewport($lockSection[0])) {
          isScrolled = true;
          asyncSweetScroll($lockSection);
        }
      }

      $form
        .find('.b-input-v4.agreement-confirmation, .b-input-v4.privacy-consent')
        .each(async (_index, warpperNode) => {
          const $checkbox = $(warpperNode).find('input[type=checkbox]');
          if (!$checkbox.length || $checkbox.is(':checked')) { return; }

          e.preventDefault();
          e.stopImmediatePropagation();

          warpperNode.classList.add('field_with_errors');
          $checkbox.one('change', () => warpperNode.classList.remove('field_with_errors'));

          if (!isVisibleInViewport(warpperNode) && !isScrolled) {
            asyncSweetScroll(warpperNode);
          }
        });
    });

  const $privacyConcentLink = $('.privacy-consent a');
  if ($privacyConcentLink.length) {
    const $profileInputs = $('.profile-form input[type=text]');

    $profileInputs.on('change', ({ currentTarget }) => {
      const formAttributes = $profileInputs.toArray().reduce((memo, input) => {
        memo[input.getAttribute('name')] = input.value;
        return memo;
      }, {});

      const urlTemplate = $privacyConcentLink.prop('href');
      const newUrl = new TinyUri(urlTemplate)
        .query
        .merge(formAttributes).toString();
      $privacyConcentLink.prop('href', newUrl);
    });
  }
});

pageLoad('boxes_show', () => {
  if (!document.querySelector('.boxes-v4-show')) { return; }

  $('.order-column')
    .on('order-column:process', process)
    .trigger('order-column:process');
});

function process({ currentTarget }) {
  const $root = $(currentTarget);
  let couponForm = null;

  $root
    .find('.b-input-v4:has(select)')
    .each((_index, node) => new CustomSelect(node));

  $root
    .find('.order-details .b-input-v4:has(select)')
    .on('custom-select:change', sync);

  $root
    .find('input[type="checkbox"], input[type="radio"]')
    .on('change', sync);

  $root
    .find('.coupon-form')
    .on('popper:show', async ({ currentTarget }) => {
      couponForm ||= new ComposableForm(currentTarget, {
        fields: ['#order_coupon_code'],
        submit: '.apply-coupon'
      });

      await delay(350);
      $('#order_coupon_code').focus();
    });

  $root
    .find('.apply-coupon')
    .on('click', e => {
      e.preventDefault();
      if (e.currentTarget.disabled) { return; }

      applyCouponCode();
    });

  $root.find('.b-tooltip_trigger-v4')
    .each((_index, node) => new PopperTooltipV4(node));

  $root
    .find('.remove-coupon')
    .on('click', () => {
      $('#order_coupon_code').val('');
      sync();
    });

  $root
    .find('.remove-lock')
    .on('click', () => {
      $(`${LOCK_RADIO_SELECTOR}`).prop('checked', false);
      sync();
    });

  $root
    .find('.rent:not(a)')
    .one('click', async ({ currentTarget }) => {
      const $trigger = $(currentTarget);

      if (authModal) {
        authModal.destroy();
      }

      authModal = makeVueModal({
        trigger: $trigger[0],
        vue: {
          importComponent: async () => await import('@/vue/modals/auth'),
          props: {
            graphqlUrl: $trigger.data('graphql_url'),
            confirmationUrl: $trigger.data('confirmation_url'),
            confirmationType: $trigger.data('confirmation_type'),
            resendCodeInterval: $trigger.data('resend_code_interval'),
            nextUrl: $trigger.data('next_url'),
            privacyUrl: $trigger.data('privacy_url')
          }
        },
        isModalCloseHandler: true,
        onShow: () => {
          track($trigger.data('track-event-data'));
        }
      })
        .show();
    });
}

async function applyCouponCode() {
  const $form = $('.coupon-form');
  const $input = $('#order_coupon_code');
  const $bInput = $input.closest('.b-input-v4');
  const $submit = $('.apply-coupon');

  $form.addClass('is-syncing');
  $submit.prop('disabled', true);

  const checkUrl = $submit.data('coupon_check_url');
  const code = $input.val();

  const [{ data: { coupon } }] = await Promise.all([
    axios.post(checkUrl, { code }),
    delay(350) // set min delay for smoother "syncing" animations
  ]);

  if (coupon) {
    $bInput.removeClass('field_with_errors');
    $form.trigger('popper:hide');
    sync();
  } else {
    $bInput.addClass('field_with_errors');
    $input.focus();
  }

  $form.removeClass('is-syncing');
  $submit.prop('disabled', false);
}

async function sync() {
  const $orderColumn = $('.order-column');
  $orderColumn.addClass('is-syncing');

  const fetchUrl = applyOrderUrlParams($orderColumn.data('fetch_url'));
  syncCurrentUrl();
  const [{ data }] = await Promise.all([
    axios.get(fetchUrl),
    delay(350) // set min delay for smoother "syncing" animations
  ]);

  $orderColumn
    .html(data)
    .trigger('order-column:process');

  $orderColumn.removeClass('is-syncing');

  $('.b-form').trigger('composable_form:validate');
}

function syncCurrentUrl() {
  const url = applyOrderUrlParams(window.location.href);
  window.history.replaceState({ turbolinks: true, url }, '', url);
}

function applyOrderUrlParams(url) {
  const orderFields = $('.order-column')
    .closest('form')
    .serializeArray();
    // .filter(({ name }) => name.startsWith('order['));

  return new TinyUri(url)
    .query
    .merge(
      orderFields.reduce((memo, { name, value }) => {
        memo[name] = value;
        return memo;
      }, {})
    ).toString();
}
